// extracted by mini-css-extract-plugin
export default {"wrapper":"web_wrapper__bNCLu"};